"use client";
import type { IconButtonProps } from "@packages/ui";
import {
  IconButton,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@packages/ui";
import type { ComponentProps } from "react";

import type { EmojiPickerProps } from "./EmojiPicker";
import { EmojiPicker } from "./EmojiPicker";

type EmojiPickerIconButtonProps = {
  buttonProps: IconButtonProps;
  contentProps?: ComponentProps<typeof PopoverContent>;
  triggerProps?: ComponentProps<typeof PopoverTrigger>;
  pickerProps: EmojiPickerProps;
};

export const EmojiPickerIconButton = ({
  pickerProps,
  buttonProps,
  contentProps = {},
  triggerProps = {},
}: EmojiPickerIconButtonProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild {...triggerProps}>
        <IconButton {...buttonProps} />
      </PopoverTrigger>
      <PopoverContent
        onOpenAutoFocus={(event) => event.preventDefault()}
        {...contentProps}
      >
        <EmojiPicker {...pickerProps} />
      </PopoverContent>
    </Popover>
  );
};
